import React from 'react';
import { howItWorks } from '../../data/mock';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const HowItWorksSection = () => {
  const { isAuthenticated, setShowAuthModal } = useAuth();

  const handleGetAccess = (e) => {
    e.preventDefault();
    if (isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      setShowAuthModal('signup');
    }
  };

  return (
    <section id="how-it-works" className="py-24 px-6 bg-[#0a0a0a]">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4 block">
            How It Works
          </span>
          <h2 className="heading-2 text-white mb-4">Three Simple Steps</h2>
          <p className="body-medium text-[#737373] max-w-2xl mx-auto">
            Get a full month of content posted to your accounts. Focus on monetization, not posting.
          </p>
        </div>

        {/* Steps - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
          {howItWorks.map((step, index) => (
            <div key={step.id} className="relative group">
              <div className="bg-[#141414] border border-white/10 rounded-3xl p-8 h-full hover:border-white/20 transition-all duration-300">
                {/* Step Number */}
                <div className="text-6xl font-bold text-white/10 mb-4 group-hover:text-white/20 transition-colors duration-300">
                  {step.step}
                </div>
                
                <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                <p className="text-[#737373] leading-relaxed">{step.description}</p>
              </div>
              
              {/* Arrow connector for desktop */}
              {index < howItWorks.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-2 transform -translate-y-1/2 z-10">
                  <div className="w-4 h-4 rotate-45 border-t-2 border-r-2 border-white/20"></div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button onClick={handleGetAccess} data-testid="how-it-works-start-posting-btn" className="btn-primary inline-flex">
            Start Posting Today
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
